import { call, take, takeEvery } from 'redux-saga/effects';

import { getQcsSyncResources, qcsSyncGetResource, qcsSyncCreateResource, qcsSyncDeleteResource }
  from 'data/qcsSyncResourceSagaHelpers';
import { mkQcsSyncResourceConfig } from 'data/qcsSyncResourceTypes';

import * as actions from './actions';
import { getLastSyncDate } from './selectors';
import {
  transformResponseToDocuments,
  transformDocumentWithResponse,
  transformDocumentToRequestData } from './transformers';


// ===============================================================================================
// SAGAS functions for documents.  These are the functions responsible for communicating directly
// with external endpoints asynchronously.

// ====================================================
// ACTION WATCHERS to trigger SAGAS calls

const mkResourceConfig = (overrides) => mkQcsSyncResourceConfig({
  resourceName: 'document',
  resourceBaseUrl: '/documents',
  getLastSyncDate,

  transformResponseToResources: transformResponseToDocuments,
  transformResourceToRequestData: transformDocumentToRequestData,
  transformResourceWithResponse: transformDocumentWithResponse,

  ...overrides,
});

export function* getDocumentsActionWatcher() {
  while (true) {
    const action = yield take(actions.getDocuments);
    const config = mkResourceConfig({
      successAction: actions.getDocumentsSuccess,
      failureAction: actions.getDocumentsFailure,
    });
    yield call(getQcsSyncResources, config, action);
  }
}

export function* createDocumentActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.createDocumentSuccess,
    failureAction: actions.createDocumentFailure,
  });
  yield takeEvery(actions.createDocument, qcsSyncCreateResource, config);
}

export function* deleteDocumentActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.deleteDocumentSuccess,
    failureAction: actions.deleteDocumentFailure,
  });
  yield takeEvery(actions.deleteDocument, qcsSyncDeleteResource, config);
}

export function* getDocumentActionWatcher() {
  const config = mkResourceConfig({
    successAction: actions.getDocumentSuccess,
    failureAction: actions.getDocumentFailure,
    resourceBaseUrl: '/documents/%s/original',
  });
  yield takeEvery(actions.getDocument, qcsSyncGetResource, config);
}

// ====================================================
// EXPORTS

export default [
  getDocumentsActionWatcher,
  createDocumentActionWatcher,
  deleteDocumentActionWatcher,
  getDocumentActionWatcher,
];
